import { useMemo, Fragment, ReactNode } from 'react';

import { FormFieldType } from 'types';

import { FormInputField } from './input';
import { FormRadioField } from './radio';
import { FormSelectField } from './select';
import { FieldArrayField } from './field-array';
import { DynamicFormFieldsProps } from './types';
import { FormCsvLookupField } from './csv-lookup';
import { FormScaleRatingField } from './scale-rating';
import { FormSelectCorrectField } from './select-correct';

export const DynamicFormFields = ({
  formId,
  fields,
  isSaved,
  container,
  hideLabels,
}: DynamicFormFieldsProps) => {
  const items = useMemo(() => {
    return fields.map((field, index) => {
      let fieldNode: ReactNode;
      const props = { ...field };
      if (hideLabels) {
        props.label = '';
      }
      switch (props.type) {
        case FormFieldType.INPUT:
          fieldNode = <FormInputField key={props.id} {...props} />;
          break;
        case FormFieldType.SELECT:
          fieldNode = props.options?.correctOptions ? (
            <FormSelectCorrectField
              key={props.id}
              {...props}
              disabled={isSaved ? isSaved(props.id) : false}
            />
          ) : (
            <FormSelectField key={props.id} {...props} />
          );
          break;
        case FormFieldType.RADIO:
          fieldNode = <FormRadioField key={props.id} {...props} />;
          break;
        case FormFieldType.SCALE_RATING:
          fieldNode = <FormScaleRatingField key={props.id} {...props} />;
          break;
        case FormFieldType.FIELD_ARRAY:
          fieldNode = (
            <FieldArrayField key={props.id} formId={formId} {...props} />
          );
          break;
        case FormFieldType.CSV_LOOKUP:
          fieldNode = (
            <FormCsvLookupField key={props.id} formId={formId} {...props} />
          );
          break;
        default:
          fieldNode = <Fragment key={index} />;
          break;
      }
      return container ? container(field, fieldNode, index) : fieldNode;
    });
  }, [fields, container, formId, isSaved, hideLabels]);

  return <>{items}</>;
};
